import BaseValidator from "./BaseValidator";

const simpleUrlValidator = Object.create(BaseValidator);

// https://stackoverflow.com/questions/3809401/what-is-a-good-regular-expression-to-match-a-url
simpleUrlValidator.validateAgainstRegex =
  /[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/i;

export default simpleUrlValidator.init();
